module.exports = __webpack_public_path__ + "static/media/15.431ac3c3.png";